import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Upload } from 'antd';
import { WorkflowImportDialog } from '..';
import security from '../../../common/services/SecurityService';
import InstructWorkflowImportExportStore from '../../stores/InstructWorkflowImportExportStore';
import './WorkflowUploader.less';

interface Props {
    importExportStore: InstructWorkflowImportExportStore;
}

const WorkflowUploader: React.FC<Props> = ({ importExportStore }) => {
    if (!importExportStore.project) {
        return null;
    }

    return (
        <>
            <WorkflowImportDialog importExportStore={importExportStore} />

            <Upload
                name="file"
                className="headerButton workflow-uploader"
                maxCount={1}
                headers={{ Authorization: `Bearer ${security.token}` }}
                action={importExportStore.importAction}
                onChange={importExportStore.onImportChange}
            >
                <div data-id="button-Import">
                    <i className="alpha-icon xs arrow-down" />
                    <span>Import</span>
                </div>
            </Upload>
        </>
    );
};

export default observer(WorkflowUploader);
